import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/op/risk_word_list',
    ADD: '/op/risk_word_add',
    UPDATE: '/op/risk_word_update',
    DEL: '/op/risk_word_del',
    IS_EXIST: '/op/risk_word_is_exist',
}

export async function riskWordList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function riskWordAdd(form) {
    return requestPost(api.ADD, form);
}

export async function riskWordUpdate(form) {
    return requestPost(api.UPDATE, form);
}

export async function riskWordDel(id) {
    let params = {
        id: id,
    };
    return requestPost(api.DEL, params);
}

export async function riskWordIsExist(val) {
    const params = { val };
    return requestGet(api.IS_EXIST, params);
}
